import * as React from 'react';
import { History } from 'history';
import { Row, Col, Button, Tooltip } from 'reactstrap';
import EditableLabel from 'react-inline-editing';
import { toastr } from "react-redux-toastr";
import { timestampToMoment } from 'src/share/utils/utils';
import routes from 'src/modules/Routing/routes';
import { GeoSearchService } from 'src/share/services/geoSearch';

export interface IGeoSearchCardProps {
    id: string;
    caseId: string;
    date: number;
    radius: number;
    title: string | undefined;
    history: History;
    editable?: boolean;
}

export const GeoSearchCard: React.SFC<IGeoSearchCardProps> = (props) => {
    const { id, caseId, date, radius, title, editable } = props;
    const [searchName, setSearchName] = React.useState(title);
    const editableEl = React.useRef<EditableLabel>(null);
    const [showIcon, setShowIcon] = React.useState(true);
    const [isTooltipOpen, setIsTooltipOpen] = React.useState(false);
    async function handleLabelFocusOut(text): Promise<void> {
        const prevText = searchName;
        if (!text) {
            setSearchName(prevText);
            setShowIcon(true);
            return;
        }
        try {
            setSearchName(text);
            setShowIcon(true);
            await GeoSearchService.updateSearchName(id, text);
        } catch (error) {
            setSearchName(prevText);
            setShowIcon(true);
            toastr.error("Error", error.payload);
        }
    }
    function handleLabelFocused(): void {
        setShowIcon(false);
    }
    function handleIconClicked(): void {
        editableEl.current._handleFocus();
    }
    return (
        <Col className={"col-12"}>
            <div className="info-card white-background geo-search-card">
                <Row>
                    <Col className={"col-12 card-content"}>
                        {editable ?
                            <div className="label-row" id={`editable-label-${id}`}>
                                <EditableLabel
                                    ref={editableEl}
                                    text={searchName}
                                    labelClassName='label-text'
                                    inputClassName='label-input'
                                    inputMaxLength={50}
                                    onFocusOut={handleLabelFocusOut}
                                    onFocus={handleLabelFocused}
                                />
                                {showIcon && <span className="label-icon fa fa-pencil-square-o" onClick={handleIconClicked} />}
                                <Tooltip placement="top-start" target={`editable-label-${id}`} isOpen={isTooltipOpen} toggle={() => setIsTooltipOpen(!isTooltipOpen)}>
                                    Click to edit the identifier
                                </Tooltip>
                            </div>
                            :
                            <h4>{title || 'Unknown'}</h4>}
                        <p className="date subFont">{date ? `created ${timestampToMoment(date).fromNow()}` : 'Unknown'}</p>
                        <p>
                            <b>{editable ? "Search Id:" : "Case Id:"} </b>
                            <span className="subFont">{editable ? id : caseId}</span>
                        </p>
                        <p><i className="fa fa-dot-circle-o" aria-hidden="true" /><span className="subFont">{radius} miles radius</span></p>
                    </Col>
                </Row>
                <Row>
                    <Col className="text-right" md="12" sm="12" xs="12">
                        <Button onClick={(): void => props.history.push(`${routes.GEOSEARCH_RESULT.replace(':searchId', id)}`)} className={"btn-blue"}>
                            View
                        </Button>
                    </Col>
                </Row>
            </div>
        </Col>
    )
};